import { React, useState } from "react";
import Sidebar from "../components/Sidebar";
import Skills from "./page_components/Skills";
import Timeline from "./page_components/Timeline";

const More = () => {
  const [activeId, setActiveId] = useState("more-timeline");
  const sidebarItems = new Map();
  sidebarItems.set("more-timeline", "Timeline");
  sidebarItems.set("more-strengths", "Skills");

  const itemContents = new Map();

  itemContents.set("more-timeline", <Timeline />);
  itemContents.set("more-strengths", <Skills />);
  const sideBarOnClick = (e) => {
    setActiveId(e.target.id);
  };

  const contents = [];

  itemContents.forEach((content, id) => {
    const element = (
      <div className={activeId === id ? "visible block h-full" : "hidden "}>
        {content}
      </div>
    );
    contents.push(element);
  });
  return (
    <div
      id="resume-wrapper"
      className="flex w-full grow flex-row justify-between"
    >
      <Sidebar
        items={sidebarItems}
        activeId={activeId}
        sideBarOnClick={sideBarOnClick}
      />
      <div id="main" className="w-2/3 grow pr-7">
        {contents}
      </div>
    </div>
  );
};

export default More;
